import { render, staticRenderFns } from "./Stempelungen.vue?vue&type=template&id=f85eb580&scoped=true"
import script from "./Stempelungen.vue?vue&type=script&lang=ts"
export * from "./Stempelungen.vue?vue&type=script&lang=ts"
import style0 from "./Stempelungen.vue?vue&type=style&index=0&id=f85eb580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85eb580",
  null
  
)

export default component.exports